/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT Decoder — Read a JSON Web Token | Toolverse`)
};

const es_jw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT Decoder — Lee un JSON Web Token | Toolverse`)
};

const de_jw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT-Decoder — Ein JSON Web Token lesen | Toolverse`)
};

const nl_jw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT Decoder — Een JSON Web Token lezen | Toolverse`)
};

const fr_jw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décodeur JWT — Lire un jeton JWT | Toolverse`)
};

const it_jw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT Decoder — Leggi un JSON Web Token | Toolverse`)
};

const pt_br2_jw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT Decoder — Leia um JSON Web Token | Toolverse`)
};

const pt_jw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descodificador JWT — Leia um JSON Web Token | Toolverse`)
};

const ja_jw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT デコーダー — JSON Web Tokenを読む | Toolverse`)
};

const zh_jw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT 解码器——读取 JSON Web Token | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_meta_title", locale)
	if (locale === "en") return en_jw_meta_title(inputs)
	if (locale === "es") return es_jw_meta_title(inputs)
	if (locale === "de") return de_jw_meta_title(inputs)
	if (locale === "nl") return nl_jw_meta_title(inputs)
	if (locale === "fr") return fr_jw_meta_title(inputs)
	if (locale === "it") return it_jw_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_jw_meta_title(inputs)
	if (locale === "pt") return pt_jw_meta_title(inputs)
	if (locale === "ja") return ja_jw_meta_title(inputs)
	return zh_jw_meta_title(inputs)
};